<!-- TEMPLATE -->
<template>
  <transition name="fade">
    <div class="dean-alert-dialog-container">
      <div :class="deanAlertDialogClass" class="row">
        <div v-if="data.icon" class="all-1-half columns info-icon">
          <dean-icon :glyph="data.icon" width="20"></dean-icon>
        </div>
        <div v-else class="all-1-half columns info-icon">
          <dean-icon :glyph="alertIcon" width="15"></dean-icon>
        </div>
        <div class="all-7 columns dean-alert-dialog-text">
          {{ data.text }}
        </div>
        <div class="all-3-half columns">
          <div class="end-icon" v-if="closeButton">
            <slot name="end-slot"></slot>
            <dean-icon @click.native="closeClick" :glyph="rightIcon" width="20"></dean-icon>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

// SVG
import emptyIcon from '../svg/icons/empty.svg';
import closeIcon from '../svg/feather-icons/x.svg';
import trashIcon from '../svg/feather-icons/trash.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanIcon
  }
})
export default class deanAlertDialog extends Vue {
  // PROPS
  @Prop() data!: object;
  @Prop() theme!: string;
  @Prop({ default: false }) standard!: boolean;
  @Prop({ default: false }) success!: boolean;
  @Prop({ default: false }) info!: boolean;
  @Prop({ default: false }) warning!: boolean;
  @Prop({ default: false }) danger!: boolean;
  @Prop({ default: true }) closeButton!: boolean;
  @Prop({ default: false }) closeTrash!: boolean;

  // DATA
  closeIcon: object = closeIcon;
  trashIcon: object = trashIcon;
  alertIcon: object = emptyIcon;
  close: boolean = false;

  // EMITS
  @Emit('close') closeClick() {}

  get rightIcon() {
    if (this.closeTrash) {
      return this.trashIcon
    } else {
      return this.closeIcon
    }
  }

  // COMPUTED
  get deanAlertDialogClass() {
    let value = 'dean-alert-dialog';
    if (this.standard) value += ` dean-alert-dialog-standard`;
    else if (this.success) value += ` dean-alert-dialog-success`;
    else if (this.info) value += ` dean-alert-dialog-info`;
    else if (this.warning) value += ` dean-alert-dialog-warning`;
    else if (this.danger) value += ` dean-alert-dialog-danger`;
    else value += `  dean-alert-dialog-standard`;
    if (this.theme) {
      value += `  dean-alert-dialog-${this.theme}`;
    }
    return value;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

.dean-alert-dialog-container {
  /* position: fixed;
  top: 90px;
  @include calc(left,"50% - 160px");
  z-index: 999; */
  padding: 5px 10px 5px 10px;
  width: 100%;

  .dean-alert-dialog {
    @include display-flex();
    align-items: center;
    justify-content: flex-start;
    @include border-radius(10px);
    z-index: 998;
    padding: 10px;
    width: 100%;
    text-align: center;

    .info-icon,
    .end-icon {
      display: flex;
      height: 20px;
      cursor: pointer;
    }
    .info-icon {
      justify-content: flex-start;
      align-self: flex-start;
    }
    .end-icon {
      justify-content: flex-end;
      align-self: flex-start;
    }

    .dean-alert-dialog-text {
      overflow-wrap: break-word;
      @include hyphens(auto);
    }
  }
  .dean-alert-dialog-standard {
    color: var(--color-dark-shade-4, $color-dark-shade-4);
    fill: var(--color-dark-shade-4, $color-dark-shade-4);
    background: var(--color-light-shade-2, $color-light-shade-2);
    border: 1px solid var(--color-light, $color-light);
  }

  .dean-alert-dialog-success {
    color: var(--color-info-success, $color-info-success);
    fill: var(--color-info-success, $color-info-success);
    background: var(--color-info-success-bg, $color-info-success-bg);
    border: 1px solid
      var(--color-info-success-border, $color-info-success-border);
  }

  .dean-alert-dialog-info {
    color: var(--color-info-standard, $color-info-standard);
    fill: var(--color-info-standard, $color-info-standard);
    background: var(--color-info-standard-bg, $color-info-standard-bg);
    border: 1px solid
      var(--color-info-standard-border, $color-info-standard-border);
  }

  .dean-alert-dialog-warning {
    color: var(--color-info-warning, $color-info-warning);
    fill: var(--color-info-warning, $color-info-warning);
    background: var(--color-info-warning-bg, $color-info-warning-bg);
    border: 1px solid
      var(--color-info-warning-border, $color-info-warning-border);
  }

  .dean-alert-dialog-danger {
    color: var(--color-info-danger, $color-info-danger);
    fill: var(--color-info-danger, $color-info-danger);
    background: var(--color-info-danger-bg, $color-info-danger-bg);
    border: 1px solid var(--color-info-danger-border, $color-info-danger-border);
  }
}
</style>
